<template>
  <popup v-model="isActive">
    <div class="messageMode">
      <div class="saveMessage">
        <div class="icon-x" @click="determine('on-close')"></div>
        <h5>{{ title }}</h5>
        <p>{{ text }}</p>
        <ul class="btn-group">
          <li class="cancel" @click="determine('on-cancel')">
            {{ cancelText }}
          </li>
          <li id="confirm-sure" class="sure" @click="determine('on-sure')">
            {{ sureText }}
          </li>
        </ul>
      </div>
    </div>
  </popup>
</template>
<script>
import Popup from './Popup'

export default {
  components: {
    Popup
  },
  props: {
    title: {
      type: String,
      default: function () {
        return "提示";
      }
    },
    text: {
      type: String,
      default: function () {
        return '确认退出登陆?';
      }
    },
    cancelText: {
      type: String,
      default: function () {
        return "取消";
      }
    },
    sureText: {
      type: String,
      default: function () {
        return "确认";
      }
    },
    value: Boolean,
  },
  data () {
    return {
      isActive: this.value
    }
  },
  methods: {
    determine (operation) {
      this.$emit(operation);
      this.isActive = false;
    }
  },
  watch: {
    isActive (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.isActive = val;
    }
  }
}
</script>
<style lang="scss">
@import "../../static/sass/_variable.scss";
.messageMode {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 99;
}
.saveMessage {
  position: absolute;
  top: 6.2rem;
  /*left:50%;*/
  /*width:268px;*/
  left: 10%;
  width: 80%;
  height: 151px;
  /*<!--transform:translateX(-50%);-->*/
  text-align: center;
  background-color: #ffffff;
  color: #333333;
  z-index: 100;

  h5 {
    font-size: 15px;
    margin: 32px 0px 15px 0px;
    font-weight: bold;
  }
  p {
    font-size: 13px;
  }
  .btn-group {
    border-top: 1px solid #dbdbdb;
    position: absolute;
    bottom: 0px;
    width: 100%;
    @include display-flex();
    li {
      text-align: center;
      height: 1rem;
      line-height: 1rem;
      @include flex(1);
      &:first-child {
        @include border(right);
      }
    }
  }
  .cancel {
    color: #f22f2f;
  }
}
</style>


// WEBPACK FOOTER //
// Confirm.vue?7b28d3bf